import React, { useState, useEffect } from 'react';
import {
  Typography,
  Card,
  Space,
  Button,
  Table,
  Input,
  Modal,
  Image,
  Tag,
  Popconfirm,
  Switch,
  Segmented,
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
// import { Segmented } from 'antd';
import { AppstoreOutlined, BarsOutlined } from '@ant-design/icons';
import BackOfficeService from '../../services/BackOfficeService';
import { useAuth } from '../../hooks/useAuth';

const { Title, Text } = Typography;

export const AdministrationItem = () => {
  const location = useLocation();
  const [applicationList, setApplicationList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { showNotification } = useAuth();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalCount, setTotalcount] = useState(0);
  const [open, setOpen] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [clickedId, setClickedId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { confirm } = Modal;

  const loadData = async () => {
    const searchParams = new URLSearchParams(location.search);
    const pageParam = searchParams.get('page') || 1;
    const sizeParam = searchParams.get('size') || 10;
    setPage(Number(pageParam) || 1);
    setSize(Number(sizeParam) || 10);
    setLoading(true);
    const response = await BackOfficeService.getBackOfficerList({
      page: pageParam,
      size: 10,
    });

    console.log(response.backOfficeUserList);
    if (response.success === true) {
      setApplicationList(
        response.backOfficeUserList.map((item, i) => ({ key: i.toString(), ...item })),
      );
      setTotalcount(response.totalCount);
    } else {
      showNotification('error', response.message);
    }
    setLoading(false);
  };

  const handleResetPassword = async id => {
    setConfirmLoading(true);
    const response = await BackOfficeService.resetPassword({
      userId: id,
    });
    setOpen(false);
    setClickedId(null);
    setConfirmLoading(false);
    if (response.success) {
      showNotification('success', 'Reseted! Check user inbox!');
    } else {
      showNotification('error', response.message);
    }
    console.log(response);
  };

  const handleDeleteUser = async id => {
    setConfirmLoading(true);
    const response = await BackOfficeService.deleteUser({
      backOfficeUserId: id,
    });
    setDeleteOpen(false);
    setClickedId(null);
    setConfirmLoading(false);
    if (response.success) {
      showNotification('success', 'Sucessfully Deleted!');
    } else {
      showNotification('error', response.message);
    }
    console.log(response);
    loadData();
  };

  const handleModifyStatus = async (id, status) => {
    setConfirmLoading(true);
    const response = await BackOfficeService.modifyUserStatus({
      backOfficeUserId: id,
      userStatusType: status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
    });
    setOpen(false);
    setClickedId(null);
    setConfirmLoading(false);
    if (response.success) {
      loadData();

      showNotification('success', 'Done! Successfully modified user status.');
    } else {
      showNotification('error', response.message);
    }
    console.log(response);
  };

  const handleCancel = () => {
    console.log('Clicked cancel button');
    setOpen(false);
    setStatusOpen(false);
    setDeleteOpen(false);
    setClickedId(null);
  };

  const showPopconfirm = (id, type) => {
    setClickedId(id);
    if (type === 'status') {
      setStatusOpen(true);
      setDeleteOpen(false);
      setOpen(false);
    } else if (type === 'delete') {
      setDeleteOpen(true);
      setStatusOpen(false);
      setOpen(false);
    } else {
      setStatusOpen(false);
      setDeleteOpen(false);
      setOpen(true);
    }
  };

  useEffect(() => {
    loadData();
  }, [location.search]);

  const tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
    },
    {
      title: 'Realm',
      dataIndex: 'realm',
      key: 'realm',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: 'Status',
      key: 'userStatus',
      render: (_, record) => (
        <Popconfirm
          title={record.name}
          description="Are you sure to inactivate this user?"
          open={clickedId === record.backOfficeUserId && statusOpen}
          onConfirm={() => handleModifyStatus(record.backOfficeUserId, record.userStatus)}
          okButtonProps={{ loading: confirmLoading }}
          onCancel={handleCancel}
        >
          <Tag style={{ borderRadius: '20px' }}>{record.userStatus}</Tag>
          <Button
            type={'link'}
            icon={<Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />}
            onClick={() => showPopconfirm(record.backOfficeUserId, 'status')}
          />
        </Popconfirm>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <Popconfirm
            title={record.name}
            description="Are you sure to reset password for this user?"
            open={clickedId === record.backOfficeUserId && open}
            onConfirm={() => handleResetPassword(record.backOfficeUserId)}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
          >
            <Button size={'small'} danger onClick={() => showPopconfirm(record.backOfficeUserId)}>
              Reset
            </Button>
          </Popconfirm>
          <Popconfirm
            title={record.name}
            description="Are you sure to delete this user?"
            open={clickedId === record.backOfficeUserId && deleteOpen}
            onConfirm={() => handleDeleteUser(record.backOfficeUserId)}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
          >
            <Button
              type={'link'}
              icon={
                <Image src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} preview={false} />
              }
              onClick={() => showPopconfirm(record.backOfficeUserId, 'delete')}
            />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <>
      <Space
        direction="horizontal"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          User
        </Title>

        <Button
          type="primary"
          size={'middle'}
          // icon={<PlusCircleOutlined />}
          onClick={() => navigate('create')}
        >
          Create
        </Button>
      </Space>

      {/* <Space.Compact style={{ float: 'right', marginBottom: '1rem' }}>
        <Input
          addonAfter={<SearchOutlined />}
          placeholder="Search"
          size={'middle'}
          allowClear
          onChange={e => setSearchText(e.target.value)}
        />
      </Space.Compact> */}

      <Table
        columns={tableColumns}
        dataSource={applicationList}
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        loading={loading}
        bordered
        pagination={{
          current: page,
          pageSize: size,
          total: totalCount,
        }}
        onChange={(pagination, filters, sorter) => {
          navigate(`/administration?page=${pagination.current}&size=${pagination.pageSize}`);
        }}
      />
    </>
  );
};
